import { DashboardSpec, PanelRef } from '@chronosphereio/viz-framework-core';

/**
 * Resolve a PanelRef (JSON reference) against the provided DashboardSpec to
 * a PanelDefinition.
 */
export function resolvePanelRef(spec: DashboardSpec, panelRef: PanelRef) {
  const panelsKey = getPanelKeyFromRef(panelRef);
  const panelDefinition = spec.panels[panelsKey];
  if (panelDefinition === undefined) {
    throw new Error(`Could not resolve panels reference ${panelRef.$ref}`);
  }
  return panelDefinition;
}

// Currently, panel refs are prefixed with `#/spec/panels/`. If that format changes, we'll definitely need to update
// the code in here relying on it being that format.
const REF_PREFIX_LENGTH = 14;

/**
 * Gets the unique key for a panel from a PanelRef.
 */
export function getPanelKeyFromRef(panelRef: PanelRef) {
  return panelRef.$ref.substring(REF_PREFIX_LENGTH);
}

/**
 * Creates a PanelRef for a panel with the given key.
 */
export function createPanelRef(panelKey: string): PanelRef {
  return { $ref: `#/spec/panels/${panelKey}` };
}
